// extracted by mini-css-extract-plugin
export default {"link":"MiscellaneousSection_link__6dKx5","subParaAlign":"MiscellaneousSection_subParaAlign__As4Q6","subParaLeftAlign":"MiscellaneousSection_subParaLeftAlign__AQNQl"};